export default "__VITE_ASSET__YhnCjdrN__"